import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.split";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import Layout from '../components/layout';
import Tabs from '../components/Tabs';
import TabContent from '../components/TabContent';
import Iframe from '../components/Iframe';
import CodeBlock from '../components/CodeBlock';
import '../styles/main.scss';
/* global __PATH_PREFIX__*/

var pathPrefix = __PATH_PREFIX__;

var ExamplePage =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ExamplePage, _React$Component);

  function ExamplePage() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ExamplePage.prototype;

  _proto.render = function render() {
    var _this$props$location = this.props.location,
        pathname = _this$props$location.pathname,
        hash = _this$props$location.hash;
    var _this$props$data = this.props.data,
        examplePageJson = _this$props$data.examplePageJson,
        file = _this$props$data.file;
    var title = examplePageJson.title,
        codeJs = examplePageJson.codeJs,
        codeHtml = examplePageJson.codeHtml;
    var selectedNavItemId = "" + pathname.split('/').pop() + hash;
    return React.createElement(Layout, {
      tabIndex: 1,
      selectedNavItemId: selectedNavItemId
    }, React.createElement("header", null, React.createElement("h2", {
      className: "title"
    }, title)), React.createElement("article", null, React.createElement(Tabs, null, React.createElement(TabContent, {
      name: "Result",
      hasIframe: true
    }, React.createElement(Iframe, {
      src: pathPrefix + "/" + file.relativePath
    })), codeJs ? React.createElement(TabContent, {
      name: "JavaScript"
    }, React.createElement(CodeBlock, {
      code: codeJs
    })) : null, codeHtml ? React.createElement(TabContent, {
      name: "HTML"
    }, React.createElement(CodeBlock, {
      code: codeHtml
    })) : null)));
  };

  return ExamplePage;
}(React.Component);

export default ExamplePage;
export var query = "4788605";